import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: `button-cancel`,
  template: `
    <button class="btn btn-primary d-print-none {{btnClass}}" (click)="onClick()" [disabled]="disabled"
            aria-label="Cancel" ngbTooltip="Cancel">
      <i class="fa fa-ban" aria-hidden="true"></i>{{ label }}
    </button>
  `
})
export class CancelbuttonComponent {
  @Output() btnClick = new EventEmitter();
  @Input() disabled = false;
  @Input() btnClass = '';
  @Input() label = '';

  onClick(): void {
    this.btnClick.emit();
  }
}
